import { Input } from '@beef/ui-kit';
import { IconSearchOutline } from '@carnica/graphics';
import classNames from 'classnames/bind';
import * as React from 'react';
import { withEventValues } from "../../../../../../../../../utils/withEventValues";
import { ModalLayout } from "../../../../../../../../../components/ModalLayout";
import { BackButton } from "../../../../../../../HeaderButtons/BackButton/BackButton";
import { Element } from "../Element";
import { ScrollWrapper } from "./ScrollWrapper";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var SearchInput = withEventValues(Input);
export var ModalWithSelection = function ModalWithSelection(_ref) {
  var items = _ref.items,
    onClose = _ref.onClose,
    onSelect = _ref.onSelect,
    search = _ref.search,
    inputHandler = _ref.inputHandler;
  return /*#__PURE__*/React.createElement(ModalLayout, {
    "data-t-id": "Carnica-ModalWithSelection"
  }, /*#__PURE__*/React.createElement(ModalLayout.Header, null, /*#__PURE__*/React.createElement("div", {
    className: cn('header')
  }, /*#__PURE__*/React.createElement(BackButton, {
    className: cn('button'),
    onClick: onClose
  }), /*#__PURE__*/React.createElement(SearchInput, {
    className: cn('search'),
    leftAside: /*#__PURE__*/React.createElement(IconSearchOutline, {
      className: cn('icon'),
      color: "secondary-invert"
    }),
    onChange: inputHandler,
    placeholder: "\u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430",
    value: search
  }))), /*#__PURE__*/React.createElement(ModalLayout.Content, null, /*#__PURE__*/React.createElement(ScrollWrapper, {
    className: cn('scroll'),
    onSelect: onSelect
  }, items.map(function (props) {
    return /*#__PURE__*/React.createElement(Element, props);
  }))));
};